import styled from 'styled-components';

export const StyledInfiniteTableWrapper = styled.div`
  position: relative;

  .table__infinite-scroll {
    .kcc-theme-table .ant-table {
      width: fit-content;

      .ant-table-content,
      .ant-table-body {
        overflow: visible !important;
      }
    }
  }
`;
